<template>
  <div>
    <Toolbar class="my-md-auto" elevation="0"  :handle-submit="onSendProdFileForm" :handle-reset="resetForm">
      <template v-slot:left>
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1 v-if="!sub"><v-icon large>mdi-file-powerpoint</v-icon>{{$t('prodfile.prodfiles')}}</h1>
        </v-toolbar-title>
      </template>

    </Toolbar>
    <ProdFileForm ref="createForm" :values="item" :errors="violations" :designfile-prop="designfile"/>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProdFileForm from '../../components/prodfile/Form';
import Loading from '../../components/Loading';
import CreateMixin from '../../mixins/CreateMixin';
import FileMixin from '../../mixins/FileMixin';
import Toolbar from "@/components/Toolbar.vue";

const servicePrefix = 'ProdFile';

const { mapFields } = createHelpers({
  getterType: 'prodfile/getField',
  mutationType: 'prodfile/updateField'
});

export default {
  name: 'ProdFileCreate',
  servicePrefix,
  mixins: [CreateMixin,FileMixin],
  components: {
    Toolbar,
    Loading,
    ProdFileForm
  },
  data() {
    return {
      item: {
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'uploaded','created', 'violations']),
  },
  methods: {
    ...mapActions('prodfile', ['create','upload', 'reset']),

    onSendProdFileForm() {
      this.onSendForm();
      this.inputfile = this.item.file;
    },

    onCreated(item) {
      if (item['name']) {
        this.showMessage(`${item['name']} ${this.$t('global.created')}`);
      } else {
        this.showMessage(`${item['@id']} ${this.$t('global.created')}`);
      }

      this.$emit('close');
      if (!this.sub){
        this.$router.push({
          name: `${this.$options.servicePrefix}Show`,
          params: { id: item['@id'] }
        });
      }

    },
  },

  props: {
    sub: {
      type: Boolean,
      required: false,
      default: false
    },
    designfile: {
      type: Object,
      required: false,
      default: null
    }
  }

};
</script>
